import React from 'react';
import '../styles/OurServicesCardDesigns.css';

// Import card images
import applicationMigration from '../../../../assets/solutions/cloudadoption/applicationmigration.png';
import dataMigration from '../../../../assets/solutions/cloudadoption/datamigration.png';
import infrastructureMigration from '../../../../assets/solutions/cloudadoption/infrastructuremigration.png';
import hybridSolutions from '../../../../assets/solutions/cloudadoption/hybridsolutions.png';
import cloudTransformation from '../../../../assets/solutions/cloudadoption/cloudtransformation.png';
import securityCompliance from '../../../../assets/solutions/cloudadoption/securitycompliance.png';

const OurServicesCardDesigns = () => {
  const services = [
    {
      title: "Application Migration",
      description: "Move legacy and modern applications using the right strategy for your needs.",
      image: applicationMigration
    },
    {
      title: "Data Migration",
      description: "Securely transfer databases, files, and unstructured data with integrity and compliance.",
      image: dataMigration
    },
    {
      title: "Infrastructure Migration",
      description: "Shift servers, storage, and networking to the cloud, optimizing for performance and cost.",
      image: infrastructureMigration
    },
    {
      title: "Hybrid & Multi-Cloud Solutions",
      description: "Integrate on-premises and cloud resources for flexibility and resilience.",
      image: hybridSolutions
    },
    {
      title: "Cloud-Native Transformation",
      description: "Modernize your IT landscape with microservices, containers, and serverless architectures.",
      image: cloudTransformation
    },
    {
      title: "Security & Compliance",
      description: "Implement robust identity management, encryption, monitoring, and compliance controls.",
      image: securityCompliance
    }
  ];

  return (
    <div className="services-container">
      <h1 className="services-title">Our Services </h1>
      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-card">
            <img src={service.image} alt={service.title} className="service-image" />
            <h3 className="service-title">{service.title}</h3>
            <p className="service-description">{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurServicesCardDesigns;
